module.exports = __webpack_public_path__ + "static/img/yycj_03.e8c0f12.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/yycj_03.png
// module id = Gk20
// module chunks = 2